export default __webpack_public_path__ + "static/media/close-btn.1792c477.webp";